export const actions = () => {
  return {
    /*
    * After an input is done, all depenended Fields needs to be updated
    * After Update a Validation of all fields needs to be done
    */

    didInputFkt (context, payload, validate = false) {
      const fieldKey = payload.key
      const order = context.getters.currentOrder
      // TODO add a mutation for this?
      // store.state.calculatorData.tinyLink = ''
      /**
       * insulationMaterial and elementForm mutations don't have to be inside the loop
       */
      if (fieldKey === 'insulationMaterial') {
        const backupExists = Object.keys(context.state.orderBackup).length > 0
        if (order.insulationMaterial !== payload.value && !backupExists) {
          /**
           * If a new insulationmaterial is set and one has been set before, the following actions must be done:
           * backup the important fields from the currentOrder object
           * make a full reset of the application
           * the currentOrderBackup is then reread into the application by the step 2 mutation
           */
          const currentOrderBackup = {
            a: {
              value: order.a,
              pageIndex: 2,
              fieldIndex: 0
            },
            b: {
              value: order.b,
              pageIndex: 4,
              fieldIndex: 1
            },
            c: {
              value: order.c,
              pageIndex: 3,
              fieldIndex: 0
            },
            d1: {
              value: order.d1,
              pageIndex: 3,
              fieldIndex: 1
            },
            e: {
              value: order.e,
              pageIndex: 4,
              fieldIndex: 0
            }
          }
          context.commit('resetState', currentOrderBackup) // + magie
        }
        /**
         * In case of insulationMaterial, the current order update must happen after the backup check so it cannot be done outside this if structure
         */
        context.commit('updateCurrentOrder', payload)
        context.commit('markFieldAsInputted', {
          pageIndex: 0,
          fieldIndex: 0
        })
      } else if (fieldKey === 'elementForm') {
        /**
         * In case of elementForm, the current order update must happen as the first step so it cannot be done outside this if structure
         */
        context.commit('updateCurrentOrder', payload)
        context.dispatch('setElementSpecificDefaults', payload)
        context.dispatch('setPageValuesFromOrderBackup')
        context.commit('updateCurrentOrder', {
          key: 'isBox',
          value: !order.elementForm.includes('jas')
        })
        context.commit('markFieldAsInputted', {
          pageIndex: 1,
          fieldIndex: 0
        })
      } else {
        /**
         * In all other cases which are later handled in the loop below, the update has to happen before the page specific logic
         */
        context.commit('updateCurrentOrder', payload)
      }

      context.getters.calculatorPages.forEach((page, pageIndex) => {
        page.inputFields.forEach((field, fieldIndex) => {
          if (field.fieldName === fieldKey) {
            context.commit('markFieldAsInputted', {
              pageIndex: pageIndex,
              fieldIndex: fieldIndex
            })
            // Page specific rules
            if (['a', 'a1', 'a2'].includes(fieldKey)) {
              // calculate totalLength and save and set didInput to true
              context.commit('updateCurrentOrder', {
                key: 'totalLength',
                value: order.a + order.a1 + order.a2
              })
              context.commit('markFieldAsInputted', {
                pageIndex: pageIndex,
                fieldIndex: 3
              })
              // calculate totalElements and save
              const totalLength = order.totalLength
              /*
              * Info:
              * there is a sepcific condition for the totalLengthOfOneElement for JAK and JAS.
              * So if the totalLengthOfOneElement is bigger than 3750 the totalLengthOfOneElement should be max 3000
              */
              let totalLengthOfOneElement = 0
              if ((order.elementForm === 'jas') || (order.elementForm === 'jak')) {
                totalLengthOfOneElement = (order.totalLength > 3750) ? 3000 : order.totalLengthOfOneElement
              } else {
                totalLengthOfOneElement = (order.totalLengthOfOneElement > 3000) ? 3000 : order.totalLengthOfOneElement
              }

              const totalElements = Math.ceil(totalLength / totalLengthOfOneElement)
              context.commit('updateCurrentOrder', {
                key: 'totalElements',
                value: !isNaN(totalElements) ? totalElements : 0
              })
              if ((order.elementForm === 'jasa') || (order.elementForm === 'jaka')) {
                // it's not possible to Change A1 and A2 for JASA and JAKA because of preperation.
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 1
                })
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 2
                })
              }
            } else if (['c', 'd1'].includes(fieldKey)) {
              // calculate d2 and save and set didInput to true
              context.commit('updateCurrentOrder', {
                key: 'd2',
                value: order.c - order.d1
              })
              context.commit('markFieldAsInputted', {
                pageIndex: pageIndex,
                fieldIndex: 2
              })
            } else if (['e', 'b'].includes(fieldKey)) {
              if (context.getters.elementForm !== '') {
                // calculate value of w
                let calculatedW = 0
                if (order.vacuumPanels === 'vip') {
                  // if VIP is choosen, W must not be lower than 40. You need to have at least 40 mm to add a Vip which is 20mm.
                  calculatedW = ((order.b - order.h - order.e) < (40)) ? (40) : ((order.b - order.h - order.e))
                } else {
                  calculatedW = order.b - order.h - order.e
                }
                context.commit('updateCurrentOrder', {
                  key: 'w',
                  value: calculatedW
                })

                // set w didInput to true
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 2
                })
                // set h didInput to true (h will not be updated by inputs, so it can be set to didInput = true)
                // fields[3].didInput = true
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 3
                })
              }
            } else if (['notches'].includes(fieldKey)) {
              // special Case:
              // if the elementForm is a Box, there are no Notches available.
              // so only "noNotch" can be choosen.
              // after choosing this all other inputs fields needs to be fixed
              if (order.notches === 'noNotch') {
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 1
                })
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 2
                })
              }
            } else if (['vacuumPanels'].includes(fieldKey)) {
              if (context.getters.elementForm !== '') {
                let calculatedW = 0
                if (order.vacuumPanels === 'vip') {
                  // if VIP is choosen, W must not be lower than 60. You need to have at least 40 mm to add a Vip which is 20mm.
                  calculatedW = ((order.b - order.h - order.e) < (40)) ? (40) : ((order.b - order.h - order.e))
                } else {
                  calculatedW = order.b - order.h - order.e
                }
                context.commit('updateCurrentOrder', {
                  key: 'w',
                  value: calculatedW
                })
                context.commit('markFieldAsInputted', {
                  pageIndex: 4,
                  fieldIndex: 2
                })
              }
            } else if (['profilColor', 'dripEdgeProfile', 'wallProfiles'].includes(fieldKey)) {
              if (!order.isBox) {
                // wallprofiles are only available on Boxes.
                // if an input is done, wallprofiles will be left by '' and input is triggert, so the form is valid.
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 0
                })
              }
              if ((order.elementForm === 'jakp') || (order.elementForm === 'jasp') || (order.elementForm === 'jaka') || (order.elementForm === 'jasa')) {
                // If not jak or jas set color to none and input to true
                // fields[1].didInput = true
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 1
                })
              }
              if (order.elementForm === 'jas' || order.elementForm === 'jak') {
                // you can't choose the dripEdgeProfile on jak and jas
                // fields[2].didInput = true
                context.commit('markFieldAsInputted', {
                  pageIndex: pageIndex,
                  fieldIndex: 2
                })
              }
            }
          }
        })
      })
      if (payload.validate) {
        /**
         * Validate and manipulate the local storage only if the function is called with payload.validate = true.
         * This function is recursively called quite often and by doing it this way, we can ensure that validate and setLocalStorageAndUrl are only called once per ecplicit function call and not multiple times per function call because of the recursion
         */
        context.dispatch('validate')
        context.commit('setLocalstorageAndUrl', payload)
      }
    },
    resetInputGlobal (context) {
      context.commit('resetState')
      localStorage.removeItem('sto-jalousie-konfigurator')
    },
    initLocalStorage (context) {
      /*
      * First check if URL is a Base64 Obj
      * if there is no object, check local storage and update Pageview
      */
      const localStorageInput = localStorage['sto-jalousie-konfigurator']
      const initValues = context.state.calculatorData.initValues

      var urlString = window.location // window.location.href
      var url = new URL(urlString)
      var stateParam = url.searchParams.get('state')
      let base64String = stateParam
      let myValues = ''

      try {
        let obj = atob(base64String)
        myValues = JSON.parse(obj)
      } catch (exception) {
        // myValues = JSON.parse(localStorageInput)
      }

      if (myValues === '') {
        myValues = JSON.parse(localStorageInput)
      }

      if (myValues !== '') {
        let lsObj = myValues.calculatorData.currentOrder

        // First update insulationMaterial and elementForm. Otherwise it will not update correctly
        // console.log(initValues.insulationMaterial)
        if (lsObj.insulationMaterial !== initValues.insulationMaterial) {
          context.dispatch('didInputFkt', {
            key: 'insulationMaterial',
            value: lsObj.insulationMaterial,
            validate: true
          })

          if (lsObj.elementForm !== initValues.elementForm) {
            context.dispatch('didInputFkt', {
              key: 'elementForm',
              value: lsObj.elementForm,
              validate: true
            })
            for (var key in lsObj) {
              if (key !== 'elementForm' && key !== 'insulationMaterial') {
                if (lsObj[key] !== initValues[key]) {
                  context.dispatch('didInputFkt', {
                    key: key,
                    value: lsObj[key],
                    validate: true
                  })
                }
              }
            }
          }
        }
      }

      // this.dispatch('didInputFkt', {
      //   key: 'profilColor',
      //   value: val
      // })
    },
    setElementSpecificDefaults (context, payload) {
      // console.log('--- set defaults ---')
      if (context.getters.elementForm !== '') {
        const elementFormData = require('@/configfiles/elementforms/' + context.getters.elementForm + '.js')
        const mins = elementFormData.getMins(context.state.calculatorData.currentOrder)
        /**
         * Set default values from the loaded configfile to state.calculatorData.calculatorPages and also set the defaults to the currentOrder object
         */
        context.state.calculatorData.calculatorPages.forEach((page, pageIndex) => {
          page.inputFields.forEach((field, fieldIndex) => {
            const key = field.fieldName
            // We use a Map here, because it ensures that iteration order === insertion order
            const fieldData = new Map()
            if (elementFormData.get(key)) {
              fieldData.set('default', elementFormData.get(key).default || undefined)
              fieldData.set('min', mins[key] || 0)
              fieldData.set('max', elementFormData.get(key).max || undefined)
              fieldData.set('steps', elementFormData.get(key).steps || undefined)
              const payload = {
                pageIndex: pageIndex,
                fieldIndex: fieldIndex,
                key: key,
                fieldData: fieldData
              }
              // Put everything into the store
              context.commit('setFieldDefaults', payload)
            }
          })
          if (elementFormData.get('totalLengthOfOneElement')) {
            context.commit('updateCurrentOrder', {
              key: 'totalLengthOfOneElement',
              value: elementFormData.get('totalLengthOfOneElement')
            })
          }
        })
      }
    },
    validate (context) {
      context.commit('setErrors')
      context.commit('setWarnings')
      context.commit('updateTabsSettings')
    },
    setCurrentPage (context, payload) {
      context.commit('setCurrentPage', payload)
    },
    setPageValuesFromOrderBackup (context) {
      if (context.state.orderBackup) {
        Object.keys(context.state.orderBackup).forEach(key => {
          context.commit('updateCurrentOrder', {
            key: key,
            value: context.state.orderBackup[key]
          })
          // context.state.calculatorData.currentOrder[key] = calculateSettableValue(context, key, context.state.orderBackup[key].value)
          context.commit('markFieldAsInputted', {
            pageIndex: context.state.orderBackup[key].pageIndex,
            fieldIndex: context.state.orderBackup[key].fieldIndex
          })
        })
        context.commit('deleteOrderBackup')
      }
    }
  }
}
